import { faArrowToBottom } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { getModelAuditReportTask } from 'app/api/ModelAuditReport';
import CommonButton from 'app/components/ReviewButton';
import { TRANSLATION_KEYS } from 'app/constants/transalations';
import { getApiErrorMessage } from 'app/utils/apiError';
import { downloadUrl } from 'app/utils/downloadUrl';
import { errorToast } from 'app/utils/toast';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { DownloadModelAuditReportButtonProps } from '../types';

/**
 * The task `url` is a presigned S3 link on cloud that expires after an hour,
 * so it is read from a fresh task detail call on every click rather than
 * from the (possibly stale) task list.
 */
export const DownloadModelAuditReportButton = ({
  taskId,
}: DownloadModelAuditReportButtonProps) => {
  const { t } = useTranslation(TRANSLATION_KEYS.COMMON);
  const [isFetching, setIsFetching] = useState(false);

  const handleDownload = () => {
    setIsFetching(true);
    getModelAuditReportTask(taskId)
      .then(task => {
        if (task?.status !== 'SUCCESS' || !task?.url) {
          errorToast(t('Report is not available for download.'));
          return;
        }
        downloadUrl(task.url);
      })
      .catch(error =>
        errorToast(getApiErrorMessage(error, t('Something went wrong.')))
      )
      .finally(() => setIsFetching(false));
  };

  return (
    <CommonButton
      text={t('Download')}
      onClick={handleDownload}
      disabled={isFetching}
      variant='tertiary'
      icon={<FontAwesomeIcon icon={faArrowToBottom} />}
      dataTestId='download-model-audit-report'
    />
  );
};
